import Styled from 'styled-components';
import { Modal as ReactModal } from "react-bootstrap";
import { Modal } from "antd";
const ModalWrapper = Styled(ReactModal)`
.select-address{
    .modal-header{
        border-bottom:none;
    }
}
&.Delete-modal-wrapper-item.modal.show {
    z-index: 11223;
    background: #39393996;
}
&.delete-confirmation-modal .modal-content {
    max-width: 430px;
    margin: auto;
}
&.product-info-modal-wrapper .modal-dialog.modal-dialog-centered {
    max-width: 1012px;
}
&.address-modal-overlay-wrapper .modal-dialog{
    max-width: 664px;
    margin: auto;
}
&.po-details-create-header{
 .modal-title {
    color: #1565D8;
}
}
&.table-ui-modal-wrapper .modal-dialog {
    max-width: 900px;
}
&.inventory-adjustment-modal-wrapper{
  .modal-dialog.modal-md.modal-dialog-centered {
    max-width: 644px;
}
.modal-footer{
  align-items:end;
  justify-content:end !important;
}
}
&.vendor-modal-wrapper-ui .modal-dialog.modal-dialog-centered {
    max-width: 560px;
}
&.delete-confirmation-modal {
  .modal-footer {
    justify-content: center;
}
}
img.close-modal-icon-custom {
    position: absolute;
    top: 12px;
    right: 12px;
    z-index:2;
    cursor: pointer;
}
&.modal-sku-product-wrapper {
  .modal-dialog{
    max-width: 600px;
}
}
&.add-product-flow {
  .modal-dialog{
    max-width: 808px;
}
button.btn-close {
    color: #fff !important;
    position: relative;
    border-radius: 19px;
    opacity:1;
    background: transparent;
}
.header-padding.modal-header {
    padding: 0px;
}
.modal-body{
  padding: 32px !important;
  h1{
    font-size: 18px;
    font-weight: 700;
    line-height: 30px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    margin: 0;
    margin-bottom: 35px;
    color:${({ theme }) => theme['primary-color']};
  }
}
}
&.confirmation-modal {
    .modal-dialog {
      width: 332px;
    }
    .modal-footer {
      button {
        background-color: ${({ theme }) => theme['primary-color']};
        color: ${({ theme }) => theme['white-color']};
        font-size: 14px;
        font-weight: 700;
        width: 180px;
      }
    }
  }
  &.cogs-modal-full-width .modal-dialog {
    max-width: 75%;
  }
  &.cogs-modal-scroll {
    .modal-dialog {
      max-height: 90vh;
      display: flex;
      flex-direction: column;
    }
    .modal-content {
      max-height: 90vh;
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }
    .modal-body {
      overflow-y: auto;
      max-height: calc(90vh - 60px);
      &::-webkit-scrollbar {
        width: 6px;
      }
      &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 3px;
      }
      &::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 3px;
        &:hover {
          background: #a1a1a1;
        }
      }
    }
  }
  .btn-close {
    position: absolute;
    right: 16px;
    top: 16px;
    z-index: 99;
  }
  .header-padding {
    padding-bottom: 0;
  }
`
export {ModalWrapper}

export const StyledModalWrapper = Styled(Modal)`
  .ant-modal-content {
    border-radius: 12px;
    background-color: #ffffff;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
    padding: 40px 16px 16px;

  }

  .ant-modal-header {
    border-bottom: none;
    background-color: #f0f2f5;
    border-radius: 12px 12px 0 0;
  }

  .ant-modal-title {
    font-size: 20px;
    font-weight: bold;
    color: #333;
  }

  .ant-modal-body {
    img.close-modal-icon-custom {
        position: absolute;
        top: 19px;
        right: 15px;
        background: #fff;
        cursor: pointer;
        z-index:1;
    }
  }

  .ant-modal-footer {
    border-top: none;
    padding: 12px 16px;
  }

button.ant-modal-close {
    z-index:2;
    svg{
      color: transparent;
    }
}
footer{
  display: flex;
  place-content: center;
  margin-top: 24px;
  grid-gap:22px;
  button{
    width: 100%;
  }
}
`;
